import type { ScrollerProps as MantineScrollerProps } from '@mantine/core';
import { Scroller as MantineScroller } from '@mantine/core';

import type { LockedProps } from '../types';

type ScrollerProps = Omit<MantineScrollerProps, LockedProps>;

export const Scroller = (props: ScrollerProps) => {
  return <MantineScroller {...props} />;
};
